const createJsonApiHeader = () => ({ 'Content-Type': 'application/vnd.api+json' })

const createUrlParameters = params =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

let localController

const api = (environment, utils, fetch, xmlParser) => ({
  createUrl (url, params) {
    return !params
      ? url
      : (utils.isString(params) ? `${url}?${params}` : `${url}?${createUrlParameters(params)}`)
  },

  request ({ method = 'GET', url, headers, data }) {
    localController && localController.abort()
    localController = new AbortController()
    return fetch(url, {
      method,
      headers: {
        ...(createJsonApiHeader()),
        ...headers,
      },
      ...(data ? { body: JSON.stringify(data) } : {}),
      signal: localController.signal
    })
  },

  async getXml (url) {
    const [, , , path, ...rest] = url?.split('/') || []
    if (!path) return
    const requestUrl = environment.isProduction
      ? url
      : [path, ...rest].join('/')
    // console.log(requestUrl)
    const result = await fetch(requestUrl)
    const xml = await result.text()
    const domParser = new DOMParser()
    const xmlDocument = domParser.parseFromString(xml, 'text/xml')
    return xmlParser.xmlToJson(xmlDocument)
  },
})

export default api
